import { Button, Space } from 'antd';
import styled from 'styled-components';

export const ButtonLink = styled(Button)`
  border: 0;
  line-height: 1px;
  font-size: 12px;
  &:hover,
  &:focus {
    color: #1890ff !important;
  }
  svg {
    fill: #000;
    height: 12px;
    width: 12px;
  }
`;

export const IconButton = styled(Button)`
  line-height: 1px;
  background: #c0ddfa;
  &.inactive {
    background: #eef4fa;
  }
  &:hover,
  &:focus {
    background: #c0ddfa;
    color: #1890ff !important;
  }
`;

export const CarouselHeaderWrapper = styled(Space)`
  display: flex;
  flex: 1;
  justify-content: space-between;
`;

export const TypologyNameDiv = styled(Space)`
  display: flex;
  flex: 1;
  border-radius: 4px;
  background: #f7f7f8;
  margin-bottom: 6px;
  padding: 10px;
`;

export const TypologyListDiv = styled(Space)`
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 55vh;
  overflow-y: scroll;

  .ant-space-item {
    width: 100%;
  }
`;

export const SetNameDiv = styled(Space)`
  display: flex;
  flex: 1;
  font-size: 12px;
  justify-content: space-between;
  border-radius: 4px;
  border: 1px solid #c0ddfa;
  background: #eff4f9;
  margin-bottom: 10px;
  padding: 5px 10px;

  .ant-space-item {
    width: auto;
  }
`;
